import { render, staticRenderFns } from "./publicCredit.vue?vue&type=template&id=71befcca&scoped=true&"
import script from "./publicCredit.vue?vue&type=script&lang=js&"
export * from "./publicCredit.vue?vue&type=script&lang=js&"
import style0 from "./publicCredit.vue?vue&type=style&index=0&id=71befcca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71befcca",
  null
  
)

export default component.exports